// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-row-selected {
    background: #0e3e66;
    color: #fff;
}

.saasquatch-logo {
    width: 200px;
}

/* Keep the sidebar within the viewport so a tall nav scrolls inside the
   sidebar instead of overflowing and scrolling the whole page. */
.admin-sider {
    height: 100vh;
    overflow-y: auto;
}

.admin-sider-version {
    display: block;
    padding: 8px;
    text-align: center;
    color: #aaa;
}

body {
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;iEACiE;AACjE;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,SAAS;AACb","sourcesContent":[".table-row-selected {\n    background: #0e3e66;\n    color: #fff;\n}\n\n.saasquatch-logo {\n    width: 200px;\n}\n\n/* Keep the sidebar within the viewport so a tall nav scrolls inside the\n   sidebar instead of overflowing and scrolling the whole page. */\n.admin-sider {\n    height: 100vh;\n    overflow-y: auto;\n}\n\n.admin-sider-version {\n    display: block;\n    padding: 8px;\n    text-align: center;\n    color: #aaa;\n}\n\nbody {\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
